// @flow
import * as React from "react";
import PellerexNotification from "./PellerexNotification";
import WithNotification from "./WithNotification";

const PellerexNotifications = (props) => {
  return (
    <div className="fixed top-4 right-4 z-10000 flex flex-col gap-3 max-w-sm">
      {props.notifications?.map((notification) => (
        <PellerexNotification
          key={notification.id}
          id={notification.id}
          visible={true}
          {...notification}
        />
      ))}
    </div>
  );
};

export default WithNotification(PellerexNotifications);
